import React, { useState, useEffect, useRef, createRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { Box } from "@mui/material";
import { AddCircleOutline, FiberManualRecord } from "@mui/icons-material";
import { useOnClickOutside } from "../../../../utils/utilFunctions";
import FormField from '../../../FormField';
import { mainTheme } from '../../../../themes';
import TooltipIconButton from "components/TooltipIconButton";
import ColorButton from "components/common/ColorButton";
import { Colors } from "constant";
import { splitArrayIntoChunksOfLen } from "helper";
import useProjectStore from '../../../../store-zustand/project';
import ProjectTypeRow from "./ProjectTypeRow";

const ProjectTypeSection = styled.div`  
  fieldset {
    border: 1px solid #a8a8a8;
    border-radius: 3px;
  }

  &.expanded {
    fieldset {
      border: 1px solid #e5e5e5;
    }

    .selected-type {
      color: #e5e5e5;
    }
  }

  .selected-type {
    -webkit-appearance: none;
    -moz-appearance: none;
    background-image: linear-gradient(45deg, transparent 50%, ${mainTheme.textColor.input.placeholder} 50%), linear-gradient(135deg, ${mainTheme.textColor.input.placeholder} 50%, transparent 50%);
    background-position: calc(100% - 2rem), calc(100% - 1.5rem);
    background-size: .5rem .5rem;
    background-repeat: no-repeat;
    padding: 1.2rem 1.5rem;
    min-height: 46px;
  }

  .type-list {
    border-top: 1px solid rgb(160 160 160);
    display: none;

    &.open {
      display: block;
      width: 100%;
      background: white;
      z-index: 1;
      right: 0;

      .type-item {
        &:hover {
          color: #e5e5e5;
        }
      }
    }
  }

  .type-item {
    padding: 0.7rem 1rem 0.7rem 1.5rem;
    background-color: #2F2F2F;
    // border-bottom: 1px solid #E5E8EC;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &:last-child {
      border-bottom: none;
    }

    // &.selected {
    //   color: white;

    //   &:hover {
    //     color: white !important;
    //   }
    // }

    &:hover {
      cursor: pointer;
      background-color: #232323;
    }
  }

  .color-pallete {
    position: absolute;
    z-index: 3;
    background-color: #232323;
    width: calc(100% + 2px);
    border: 1px solid rgb(160 160 160);
    border-top: none;
    left: -1px;
  }
`;


const AddProjectSection = styled.div`
  position: relative;

  .section-inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    
    border-bottom: 1px solid rgb(160 160 160);
    padding-right: 1rem;
    background-color: #2F2F2F;

    input {    
      border: none;
      border-radius: 0;
    }

    .action-groups {
      display: flex;
      align-items: center;
    }
  }

  svg.project-color {
    fill: ${props => props.color ? props.color + " !important" : ""};
  }
`;

const ProjectType = ({ edit, handle_selected_project, tag, EditedcategoryId, isCreate }) => {
  const dispatch = useDispatch();
  //const types = useSelector(state => state.project.types);
  const [types, gettypes] = useState([]);
  const [selectlisttext, setselectlisttext] = useState(tag);
  const [selectedType, setSelectedType] = useState(undefined);
  const [refresh_type_list, setrefresh_type_list] = useState();
  const { UpdateTypeColor, AddProjectTypeToDB, gettypedataById, GetProjectTypeList, RemoveTypeItem } = useProjectStore();
  const [newType, setNewType] = useState({
    label: '',
    color: '#E5E5E5'
  });

  const [isOpen, setIsOpen] = useState(false);
  const [addShowColorPicker, setAddShowColorPicker] = useState(false);
  const [selectedProject, setSelectedProject] = useState();
  const ref = useRef();
  const exceptional = createRef();

  useEffect(() => {
    async function fetchData() {
      //console.log(GetProjectTypeList, edit, isCreate, newType, refresh_type_list, selectedType, tag, types);
      if (selectedType) return;
      const Type_list = await GetProjectTypeList();
      if (Type_list !== 'Error') {
        gettypes(Type_list);
        setSelectedType(types[0]);

        if (edit === true && isCreate === true) {
          setSelectedType(types[0]);
          if (tag === undefined && selectedType === undefined) {
            setselectlisttext(types[0]?.fields?.TYPENAME);
          }
          // setNewType({ ...newType, label: types[0]?.fields?.TYPENAME, color: '#E5E5E5' });
        }
      }
      else {
        alert('Error while getting Type list');
      }
    }
    fetchData();
  }, [GetProjectTypeList, edit, isCreate, newType, refresh_type_list, selectedType, tag, types]);

  useOnClickOutside(ref, () => setAddShowColorPicker(false), exceptional);


  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleTypeClick = (value) => {
    //Edit select text value
    setselectlisttext(value.fields.TYPENAME);
    /********* */
    setSelectedType(value);
    handle_selected_project(value);
    setIsOpen(false);
  };

  const showAddColorPicker = (e) => {
    e.stopPropagation();
    setAddShowColorPicker(true);
  };

  const handleClickPicker = (value) => {
    setNewType({ ...newType, color: value });
    setAddShowColorPicker(false);
  };

  const handleProjectName = (e) => {
    setNewType({ ...newType, label: e.target.value });
  };

  const addProjectType = async () => {
    //Add New Type to DB
    const body_obj = {
      'color': newType.color,
      'label': newType.label
      //'iduser': USERID
    }
    if (newType.label !== '' && newType.color !== null) {
      const AddedTypedata = await AddProjectTypeToDB(body_obj);
      if (AddedTypedata === 500) {
        alert('Error while adding new category');
      }
      else {
        dispatch({ type: 'ADD_PROJECT_TYPE', new_type: newType });
        setNewType({ ...newType, label: '', color: '#E5E5E5' });
        //Refresh the list from the server so we can see added element 
        setrefresh_type_list(AddedTypedata);

        //Clear selected type to force refresh
        setSelectedType(undefined);
      }
      //gettypes(Type_list);
    }
    else {
      alert('Please define a label & color for the new item');
    }

  };

  const removeProjectType = async (e, id) => {
    e.stopPropagation();
    await RemoveTypeItem(id);
    setrefresh_type_list(id);
    dispatch({ type: 'REMOVE_PROJECT_TYPE', type_id: id });
    setSelectedType(types[0]);

    //Clear selected type to force refresh
    setSelectedType(undefined);

  };

  const handleShowColorPicker = (e, item) => {
    e.stopPropagation();
    setSelectedProject(item);
  };

  const hanldeProjectColor = async (color, e) => {
    const body_obj = {
      typeID: e.pk,
      Color: color
    }
    const AddedTypedata = await UpdateTypeColor(body_obj);
    //console.log(AddedTypedata);
    setrefresh_type_list(color);

    //Clear selected type to force refresh
    setSelectedType(undefined);
  };

  useEffect(() => {
    dispatch({ type: 'GET_ALL_PROJECT_TYPES' });
  });

  return (
    <>
      {
        edit && selectedType !== undefined ?
          <ProjectTypeSection className={isOpen ? 'expanded' : ''}>
            <FormField label="Project Type" id="project_type">
              <div className="selected-type" onClick={toggleDropdown}>
                {selectlisttext}
              </div>
              <div className={`type-list ${isOpen && 'open'}`}>
                <AddProjectSection color={newType.color}>
                  <div className="section-inner">
                    <input type="text" placeholder="Add Category" onChange={(e) => handleProjectName(e)} value={newType.label} />
                    <div className="action-groups">
                      <TooltipIconButton title="Color" ariaLabel="color" placement="left" size={34} onClick={showAddColorPicker}>
                        <FiberManualRecord className="project-color" />
                      </TooltipIconButton>
                      <TooltipIconButton title="Add" ariaLabel="add" placement="right" size={34} onClick={addProjectType} ref={exceptional}>
                        <AddCircleOutline />
                      </TooltipIconButton>
                    </div>
                  </div>
                  {
                    addShowColorPicker &&
                    <div className="color-pallete" ref={ref} >
                      {splitArrayIntoChunksOfLen(Colors, 8).map((itemList, index) => (
                        <Box display="flex" flexDirection="row" justifyContent="center" my="9px" key={index}>
                          {itemList.map((item, itemIndex) => (
                            <Box mx="6px" key={itemIndex}>
                              <ColorButton
                                color={item}
                                active={newType.color === item}
                                onClick={() => handleClickPicker(item)}
                              />
                            </Box>
                          ))}
                        </Box>
                      ))}
                    </div>
                  }
                </AddProjectSection>
                {types.map((item, index) => (
                  <ProjectTypeRow
                    key={index}
                    type={item}
                    selectedType={selectedType}
                    handleTypeClick={handleTypeClick}
                    removeProjectType={removeProjectType}
                    handleShowColorPicker={handleShowColorPicker}
                    hanldeProjectColor={(color) => hanldeProjectColor(color, item)}
                  />
                ))}
              </div>
            </FormField>
          </ProjectTypeSection> :
          ""
      }
    </>
  )
};

export default ProjectType;
